/* Ported from panel.davakhoone.com (TipTap 3 / Vue 3) to TipTap 2 / Vue 2 for sakhtineo. */
import Image from '@tiptap/extension-image'
import { mergeAttributes } from '@tiptap/core'

const SIZE_PATTERN = /^(?:\d+(?:\.\d+)?)(px|%|vh|vw|vmin|vmax|rem|em|ch|ex|cm|mm|in|pt|pc)$/i

export const IMAGE_ALIGN_OPTIONS = [
  { value: 'right', label: 'راست‌چین' },
  { value: 'center', label: 'وسط‌چین' },
  { value: 'left', label: 'چپ‌چین' }
]

export function normalizeImageSizeValue(value) {
  const raw = String(value || '').trim().replace(/\s+/g, '')
  if (!raw) return { ok: true, value: null }

  if (/^\d+(?:\.\d+)?$/.test(raw)) {
    return { ok: true, value: `${raw}px` }
  }

  if (SIZE_PATTERN.test(raw)) {
    return { ok: true, value: raw }
  }

  return { ok: false, value: null }
}

function buildImageStyle({ width, height, align }) {
  const styles = ['display: block', 'max-width: 100%']
  if (width) styles.push(`width: ${width}`)
  if (height) styles.push(`height: ${height}`)

  const resolvedAlign = align || 'center'
  if (resolvedAlign === 'left') {
    styles.push('margin-left: 0', 'margin-right: auto')
  } else if (resolvedAlign === 'right') {
    styles.push('margin-left: auto', 'margin-right: 0')
  } else {
    styles.push('margin-left: auto', 'margin-right: auto')
  }

  return styles.join('; ')
}

function parseAlign(element) {
  const dataAlign = element.getAttribute('data-align')
  if (dataAlign === 'left' || dataAlign === 'right' || dataAlign === 'center') {
    return dataAlign
  }

  const marginLeft = element.style.marginLeft
  const marginRight = element.style.marginRight
  if (marginLeft === 'auto' && marginRight === 'auto') return 'center'
  if (marginLeft === 'auto' && (marginRight === '0px' || marginRight === '0')) return 'right'
  if ((marginLeft === '0px' || marginLeft === '0') && marginRight === 'auto') return 'left'
  return 'center'
}

function parseSizeAttr(element, cssProp, htmlAttr) {
  const styleValue = element.style?.[cssProp]
  if (styleValue) return styleValue
  const attr = element.getAttribute(htmlAttr)
  if (!attr) return null
  if (/^\d+(?:\.\d+)?$/.test(attr)) return `${attr}px`
  return attr
}

export const EditorImage = Image.extend({
  addAttributes() {
    return {
      src: { default: null },
      alt: { default: null },
      title: { default: null },
      width: {
        default: null,
        parseHTML: (element) => parseSizeAttr(element, 'width', 'width'),
        renderHTML: () => ({})
      },
      height: {
        default: null,
        parseHTML: (element) => parseSizeAttr(element, 'height', 'height'),
        renderHTML: () => ({})
      },
      align: {
        default: 'center',
        parseHTML: (element) => parseAlign(element),
        renderHTML: (attributes) => ({
          'data-align': attributes.align || 'center'
        })
      }
    }
  },

  renderHTML({ node, HTMLAttributes }) {
    const { width, height, align } = node.attrs
    return [
      'img',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        style: buildImageStyle({ width, height, align })
      })
    ]
  }
})
